import { render, staticRenderFns } from "./moving-icon.vue?vue&type=template&id=5ce7c686&scoped=true"
import script from "./moving-icon.vue?vue&type=script&lang=js"
export * from "./moving-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7c686",
  null
  
)

export default component.exports